import { useState } from "react";
import { MDBCollapse, MDBCard, MDBCardBody } from "mdbreact";

const Collapse = ({ data }) => {
  const [collapseId, setCollapseId] = useState("");

  const toggleCollapse = (newCollapseId) =>
    setCollapseId((prevCollapseId) =>
      prevCollapseId !== newCollapseId ? newCollapseId : ""
    );

  return (
    <>
      {data.map((el, i) => (
        <MDBCard key={i} className="mt-3">
          <p
            onClick={() => toggleCollapse(`collapse${i}`)}
            className="px-4 py-2 m-0 paragraph"
            style={{ cursor: "pointer" }}
          >
            {el.title}
            <i
              className={
                collapseId === `collapse${i}`
                  ? "fa fa-angle-up rotate-icon float-right"
                  : "fa fa-angle-down float-right"
              }
            />
          </p>
          <MDBCollapse id={`collapse${i}`} isOpen={collapseId}>
            <MDBCardBody
              dangerouslySetInnerHTML={{ __html: el.text }}
              className="paragraph"
            ></MDBCardBody>
          </MDBCollapse>
        </MDBCard>
      ))}
    </>
  );
};

export default Collapse;
